import { radioAnatomy } from '@chakra-ui/anatomy';
import { createMultiStyleConfigHelpers, defineStyle } from '@chakra-ui/react';

const { definePartsStyle, defineMultiStyleConfig } = createMultiStyleConfigHelpers(
  radioAnatomy.keys,
);

const baseStyle = definePartsStyle({
  control: {
    boxSize: { mobile: '20px', laptop: '24px' },
    border: '2px solid #C4C7CF',
    bgColor: 'bg.white',

    _checked: {
      bgColor: 'transparent',
      borderColor: 'bg.accent',
      _hover: {
        bgColor: 'transparent',
        borderColor: 'bg.accent',
      },
      _before: {
        background: 'bg.accent',
        boxSize: { mobile: '8px', laptop: '10px' },
      },
    },
  },
  label: {},
  container: {
    gap: '8px',
  },
});

const md = defineStyle({
  fontSize: { mobile: '14px', laptop: '18px' },
  lineHeight: '140%',
  fontWeight: 400,
});

const sizes = {
  md: definePartsStyle({ label: md }),
};

const Radio = defineMultiStyleConfig({ baseStyle, sizes });

export default Radio;
